import { render } from "./moonAltitude.vue?vue&type=template&id=fd9f132c&ts=true"
import script from "./moonAltitude.vue?vue&type=script&lang=ts"
export * from "./moonAltitude.vue?vue&type=script&lang=ts"

import "./moonAltitude.vue?vue&type=style&index=0&id=fd9f132c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__